<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hinge';
                }
            },
            component_id: {
                default(){
                    return 'hardware_hinge';
                }
            },
            hardwareColour: {
                required: true
            },
            slab: {
                required: true
            },
            opening_direction: {
                required: true
            },
            securedByDesign: {
                required: true
            },
            hingeSide: {
                required: true
            },
            frameMaterial: {
                required: false,
                default(){
                    return '';
                }
            },
            doorRange: {
                required: true
            },
            frameProfile: {
                required: false,
                default(){
                    return '0';
                }
            },
            doorLocation: {
                required: false,
                default(){
                    return '0';
                }
            },
            hingeQty: {
                required: false,
                default(){
                    return 0;
                }
            },
            hardwareHandle: {
              required: false,
              default(){
                return 0;
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareColour, this.slab, this.opening_direction, this.hingeSide, this.frameMaterial, this.securedByDesign, this.doorRange, this.frameProfile, this.doorLocation, this.hingeQty, this.hardwareHandle);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-hinge?hardware_colour=' + this.hardwareColour
                    + '&slab=' + this.slab
                    + '&hinge_side=' + this.hingeSide
                    + '&frame_material=' + this.frameMaterial
                    + '&secured_by_design=' + this.securedByDesign
                    + '&opening_direction=' + this.opening_direction
                    + '&door_range=' + this.doorRange
                    + '&profile=' + this.frameProfile
                    + '&door_location=' + this.doorLocation
                    + '&hinge_qty=' + this.hingeQty
                    + '&hardware_handle=' + this.hardwareHandle;
            },
            cache_key(){
                return '_' + this.hardwareColour + '_' + this.slab + '_' + this.opening_direction + '_' + this.hingeSide + '_' + this.frameMaterial + '_' + this.securedByDesign + '_' + this.doorRange + '_' + this.frameProfile + '_' + this.doorLocation + '_' + this.hingeQty + '_' + this.hardwareHandle;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
